var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('download-csv',{attrs:{"data":_vm.csvRows,"name":_vm.fileName}},[_c('v-btn',{attrs:{"block":"","elevation":"0"},on:{"click":_vm.onCreatFileName}},[_vm._v(" Download (.csv) ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }